import React from 'react';
import DefaultLayout from './../components/DefaultLayout';
import { BrowserRouter, Link, Routes, Route, Switch } from "react-router-dom";

function ContactPage() {
    const content = (
        <React.Fragment>
            <p>Always open for mock interviews (any type).</p>
            <p>Discord: <code>ssh.pem</code>@.</p>
        </React.Fragment>
    );
    return (
        <React.Fragment>
            <DefaultLayout
                stack={[{"url": "/", "name": "home"}, {"url": null, "name": "contact"}]}
                title={"Contact"}
                content={content}
            />
        </React.Fragment>
    );
}

export default ContactPage;
